import { Box, Typography, Divider } from "@mui/material";
import { useStyles } from "./preview-confirm.step.style";

interface PreviewFieldProps {
  label?: React.ReactNode;
  children?: React.ReactNode;
  divider?: boolean;
}

export const PreviewField = ({ label, children, divider = true }: PreviewFieldProps) => {
  const { classes } = useStyles();
  return (
    <Box className={classes.field}>
      {label != null && (
        <Typography
          variant="body2"
          color="text.secondary"
        >
          {label}
        </Typography>
      )}
      <Box className={classes.fieldValue}>
        {typeof children === 'string' ||
          typeof children === 'number' ? (
          <Typography variant="body1" className={classes.fieldValue}>
            {children}
          </Typography>
        ) : (
          children
        )}
      </Box>
      {divider && <Divider />}
    </Box>
  );
};